export default {
  image: {
    width: '100%',
    height: '100%',
    borderRadius: 9,
    boxShadow: '0px 4px 4px 0px rgba(0, 0, 0, 0.25)',
    objectFit: 'cover',
  },
};
